<template>
  <div>
    <input-select
      id="licenseUsState"
      :value="license.usState"
      @input="updateUsState"
      name="licenseUsState"
      label="State"
      displayField="name"
      placeholder="Which US State does this license apply to?"
      placeholder-enabled
      :options="usStates"
    />
    <input-datepicker 
      id="licenseExpires"
      :value="license.expires"
      @input="updateExpires"
      :disabledDates="notBeforeToday"
      name="licenseExpires"
      label="License Expires"
      placeholder="When does this license expire?"
      placeholder-enabled
    />
    <input-select
      id="licenseType"
      :value="license.type"
      @input="updateType"
      name="licenseType"
      label="License Type"
      placeholder="Which class of license are you uploading?"
      placeholder-enabled
      :options="[           
        { id: 'CreativeArtsTherapy', display_label: 'Creative Arts Therapy' },
        { id: 'LicensedClinicalProfessionalCounselor', display_label: 'LCPC - Licensed Clinical Professional Counselor' },
        { id: 'LicensedClinicalSocialWorker', display_label: 'LCSW - Licensed Clinical Social Worker' },
        { id: 'LicensedIndependentClinicalSocialWorker', display_label: 'LICSW - Licensed Independent Clinical Social Worker' },
        { id: 'LicensedIndependentSocialWorker', display_label: 'LISW - Licensed Independent Social Worker' },
        { id: 'LicensedMarriageAndFamilyTherapist', display_label: 'LMFT - Licensed Marriage And Family Therapist' },
        { id: 'LicensedMasterSocialWorker', display_label: 'LMSW - Licensed Master Social Worker' },
        { id: 'LicensedMentalHealthCounselor', display_label: 'LMHC - Licensed Mental Health Counselor' },
        { id: 'LicensedMentalHealthPractitioner', display_label: 'LMHP - Licensed Mental Health Practitioner' },
        { id: 'LicensedProfessionalClinicalCounselorOfMentalHealth', display_label: 'LPCC - Licensed Professional Clinical Counselor of Mental Health' },
        { id: 'LicensedProfessionalCounselor', display_label: 'LPC  - Licensed Professional Counselor' },
        { id: 'PsychiatricNursePractitioner', display_label: 'Psychiatric Nurse Practitioner' },
        { id: 'Psychiatrists', display_label: 'Psychiatrists' },
        { id: 'Psychologists', display_label: 'Psychologists' },
        { id: 'Unknown', display_label: 'Other' },
      ]"
    />
    <div class="form__input">
      <input-text 
        id="licenseNumber"
        :value="license.licenseNumber"
        @input="updateLicenseNumber"
        name="licenseNumber"
        label="License Number"
      />
    </div>
    <div class="form__input">
      <label class="form__label">
        License File
      </label>
      <div class="custom-file-container">
        <b-form-file
          id="licenseFile"
          :value="license.file"
          @change="updateFile"
          name="licenseFile"
          accept="image/*,application/pdf,application/msword"
          placeholder="Select an image, PDF, DOC, or DOCX file"
          drop-placeholder="Drop file here..."
          :state="Boolean(license.file)"
        />
        <font-awesome-icon
          :icon="['fa', 'file-upload']"
          class="icon alt"
        />
      </div>
    </div>
  </div>
</template>


<script>
import UserClient from '@/api/UserClient.js'
import InputSelect from '@/components/inputs/InputSelect.vue'
import InputText from '@/components/inputs/InputText.vue'
import InputDatepicker from '@/components/inputs/InputDatepicker.vue'
import moment from 'moment'

export default {
  name:'License',
  components:{
    InputSelect,
    InputDatepicker,
    InputText,
  },
  props:{
    value: {
      type: Object,
      required: false,
      default: () => ({
        usState: null,
        type: null,
        expires: null,
        file: null,
      })
    }
  },
  data() {
    return {
      userClient: new UserClient(this.$http),

      license: {
        usState: null,
        type: null,
        licenseNumber: null,
        expires: null,
        file: null,
      },

      notBeforeToday: {
        to: moment().startOf('day').add(1, 'days').toDate()
      },

      saving: false,
      usStates: [],
    }
  },
  watch: {
    value() {
      if(this.value)
        this.license = this.value;
      else if(!this.license)
        this.license = {
          usState: null,
          type: null,
          expires: null,
          file: null,
        }
    }
  },
  async mounted() {
    if(this.value)
      this.license = this.value;
    else if(!this.license)
      this.license = {
        usState: null,
        type: null,
        expires: null,
        file: null,
      }
    const states  = await this.userClient.getStatesList('', 500);
    this.usStates = states.results || []
  },
  computed: {
    isValid(){
      return !!this.license.usState 
        && !!this.license.type 
        && !!this.license.expires 
        && !!this.license.file
        && !!this.license.licenseNumber;
    }
  },
  methods:{
    updateFile(event) {
      const file = event.target.files[0];

      this.license.file = file;
      
      this.handleEmit()
    },
    updateExpires(expires) {
      console.log(expires)
      this.license.expires = expires;
      
      this.handleEmit()
    },
    updateType(type) {
      this.license.type = type;
      
      this.handleEmit()
    },
    updateLicenseNumber(number) {
      this.license.licenseNumber = number;

      this.handleEmit();
    },
    updateUsState(state) {
      this.license.usState = state;

      this.handleEmit()
    },
    handleEmit(){
      if(!this.isValid)
        this.$emit('input', null)
      
      this.$emit('input', { ...this.license })
    }
  }
}
</script>

<style lang="scss">
</style>